// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"1f2d706f","605":"57c993f1","809":"62452d41","981":"041ebb92"}[chunkId] + ".chunk.js";
};